import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import deleteaction from "../../context/action/company/deleteaction";
import updateaction from "../../context/action/company/updateaction";

const Editcompanymodal = (props) => {
  const { initState, recaller, setrecaller, clear, initDispatch } =
    useContext(GlobalContext);

  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  const [error2, seterror2] = useState(false);
  return (
    <>
      {props.show ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative my-6 mx-auto w-11/12 md:w-11/12 lg:w-11/12 max-w-7xl">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-xl sm:text-2xl md:text-3xl uppercase font-semibold flex-1">
                    گۆڕانکاری
                  </h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-80 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => props.setshow(false)}
                  >
                    <span className="bg-transparent text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
                      X
                    </span>
                  </button>
                </div>
                {/*body*/}
                <div className="relative p-6 flex-auto">
                  <div className="flex flex-wrap w-full">
                    <div className="w-full md:w-full px-3 my-2">
                      <label
                        className={
                          error
                            ? "block uppercase tracking-wide text-red-500 text-xs font-bold mb-2"
                            : "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        }
                        for="company_name"
                      >
                        ناوی کۆمپانیا
                      </label>
                      <input
                        className={
                          error
                            ? "appearance-none block w-full bg-gray-50 text-gray-700 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                            : "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                        }
                        id="company_name"
                        type="text"
                        placeholder=""
                        onClick={(val)=>{val.target.select()}}
                        value={props.company_name}
                        onChange={(val) =>
                          props.setcompany_name(val.target.value)
                        }
                        onFocus={() => seterror(false)}
                      />
                    </div>
                    <div className="w-full md:w-full px-3 my-2">
                      <label
                        className={
                          error1
                            ? "block uppercase tracking-wide text-red-500 text-xs font-bold mb-2"
                            : "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        }
                        for="company_address"
                      >
                        ناونیشان
                      </label>
                      <input
                        className={
                          error1
                            ? "appearance-none block w-full bg-gray-50 text-gray-700 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                            : "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                        }
                        id="company_address"
                        type="text"
                        placeholder=""
                        onClick={(val)=>{val.target.select()}}
                        value={props.company_address}
                        onChange={(val) =>
                          props.setcompany_address(val.target.value)
                        }
                        onFocus={() => seterror1(false)}
                      />
                    </div>
                    <div className="w-full md:w-full px-3 my-2">
                      <label
                        className={
                          error2
                            ? "block uppercase tracking-wide text-red-500 text-xs font-bold mb-2"
                            : "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                        }
                        for="company_phone"
                      >
                        ژمارەی تەلەفۆن
                      </label>
                      <input
                        className={
                          error2
                            ? "appearance-none block w-full bg-gray-50 text-gray-700 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                            : "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                        }
                        id="company_phone"
                        type="text"
                        placeholder=""
                        onClick={(val)=>{val.target.select()}}
                        value={props.company_phone}
                        onChange={(val) =>
                          props.setcompany_phone(val.target.value)
                        }
                        onFocus={() => seterror2(false)}
                      />
                    </div>
                  </div>
                </div>
                {/*footer*/}
                <div className="flex flex-col sm:flex-row items-center justify-end gap-3 p-4 sm:p-6 border-t border-solid border-slate-200 rounded-b">
                  <button
                    className="w-full sm:w-auto bg-red-500 text-white active:bg-red-600 font-bold uppercase text-sm px-4 sm:px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 order-2 sm:order-1"
                    type="button"
                    onClick={() => {
                      if (
                        window.confirm("ئاگاداری ڕەشکردنەوە . دڵنیای ؟") == true
                      ) {
                        deleteaction(props.company_id)(recaller)(setrecaller)(
                          initDispatch
                        )(clear);
                      }
                    }}
                  >
                    ڕەشکردنەوە
                  </button>
                  <button
                    className="w-full sm:w-auto bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-4 sm:px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 order-1 sm:order-2"
                    type="button"
                    onClick={() => {
                      if (props.company_name == "" || !props.company_name) {
                        seterror(true);
                        return false;
                      }
                      if (
                        props.company_address == "" ||
                        !props.company_address
                      ) {
                        seterror1(true);
                        return false;
                      }
                      if (props.company_phone == "" || !props.company_phone) {
                        seterror2(true);
                        return false;
                      }
                      if (
                        window.confirm(
                          "ئاگاداری ئەنجامدانی گۆڕانکاری . دڵنیای ؟"
                        ) == true
                      ) {
                        updateaction(
                          props.company_id,
                          props.company_name,
                          props.company_address,
                          props.company_phone
                        )(recaller)(setrecaller)(initDispatch)(clear);
                      }
                    }}
                  >
                    گۆڕانکاری
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default Editcompanymodal;
